var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-view"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-3"},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('RecordCard')],1)]),_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('CommissionListCard')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }